import React,{useEffect, useState} from "react";
import styles from "./imagesChat.module.scss";
import { useSelector } from "react-redux";
import { initialStateModel, LoginState } from "../../../../models/model";
import FilePreview from "../filePreview";
import ChatGifInfo from "../chatGifInfo";
import { updateOpenstate } from "../../../../base/socketChatService/utils";
// import ChatHoverOption from "../chatHoverOption";
type multiimagesChatProps={
  data:any;
  previewopen?:Function;
  multiData?:any;
  audioVideo?:any;
  index:number;
}
type fileMessageState = {
  isOpen: boolean;
  id: any;
  dataRes:any;
  imgHeight:any;
  imgWidth:any;
  imgRatio:any;
  
}
export default function ImagePreview({ data,multiData,audioVideo,index}:multiimagesChatProps) {
  
  const [fileState, setfileState] = useState<fileMessageState>({ isOpen: false, id: '',dataRes:'',imgHeight:240,imgWidth:330,imgRatio:""});
  const chatSocketMessage = useSelector((state: initialStateModel) => state.chatSocketReducerState);
  const { userdetails }: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  let { messageList }: any = chatSocketMessage;

  //let messageBody = _.isObject(data.message.body) && !data?.message?.isDeleted?data.message.body:!data?.message?.isDeleted?(JSON.parse(data.message.body)):"";
  let messageBody = data.message.body;
  useEffect(() => {
    loadImage(messageBody);
  }, []);
  const aspect = (a:any, b:any) => {
    var test:any = (b === 0) ? a : aspect (b, a%b);
    return test;
  }

  const loadImage = (imageUrl:any) => {
    const img = new Image();
    img.src = imageUrl.filePath;
    img.onload = () => {
      var width = img.width;
      var height = img.height;
      var r:any = aspect (width, height);
      let ratioW = width/r;
      let ratioH = height/r;
      let ratio = width/r + ":"+ height/r
      let ImgWidth = 240;
      let ImgHeight = 330;
      let allFixel:any = {
        "2:1": 165,"5:1": 82,"5:2": 132,"5:3": 198,"5:4": 264,"10:1": 82,
        "10:3": 99,"10:7": 231,"10:9": 297,"4:5": 300,"9:10": 266,
        "1:10": 338,"1:5": 338,"1:2": 338,"2:5": 338,"3:5": 338,"3:10": 338,
        "7:10": 338,"1:1": 330,"20:1":82
      };
      if(ratioW > ratioH){
        ImgWidth = 330;
        ImgHeight = allFixel[ratio] !== undefined?allFixel[ratio]:240
      } else if(ratioW < ratioH){
        ImgWidth = 240;
        ImgHeight = allFixel[ratio] !== undefined?allFixel[ratio]:330
      } else if(ratioW === ratioH){
        ImgWidth = 330;
        ImgHeight = 330;
      }
    setfileState({...fileState,imgHeight:multiData?.length>3?240: ImgHeight,imgWidth:multiData?.length>3?330:ImgWidth,imgRatio:ratio});
    
    };
    
  }
  const previewOpen = (data:any)=>{
   // previewOpen(id);
    setfileState({...fileState,isOpen:!fileState.isOpen,id:data?.id,dataRes:data});
    updateOpenstate(true);
  };
  const FilePreviewer = ()=>{
    setfileState({...fileState,isOpen:!fileState.isOpen});
  
    updateOpenstate(false);
  };


   return (
    <>
{fileState.isOpen && <FilePreview isOpen={fileState.isOpen} data={fileState.dataRes}
              previewopen={FilePreviewer}  groupdata={messageList}/> }
            {multiData.length>3 ? <div className={`replyImgType ${styles.imageSec} ${multiData.length>3 ?"":styles.single}` } 
                 >
                     
                      <div  className={`imageDiv ${styles.imgSingle}`} onClick={()=>previewOpen(data)}>
                        <img src={messageBody.filePath} alt="" />
                        {multiData.length>=4 && 
                        <div className={multiData.length>4 && index === 3 ? styles.groupingnumber:""}>+{multiData.length - 3}</div>} </div>
                      {/* <div className={styles.attachmentHover} id={"hover"+data.id}>
                        <ChatAttachmentsOption data={data} fromFiles={false}  previewopen={previewOpen} hoverdata={Array.isArray(multiData) && multiData?.length > 0 && multiData[0]}/>
                        </div> */}
                    {(messageBody?.text === "" || messageBody?.text === undefined) &&   
                     <ChatGifInfo userDetails={userdetails}
                     timeStamp={data?.timestamp} message={data}></ChatGifInfo>
                    }
                  </div>
                  
                  :<div className={`replyImgType ${styles.imageSec} ${multiData.length>3 ?"":styles.single}` } 
                  style={{ minHeight:  fileState.imgHeight,maxHeight:  fileState.imgHeight, width: fileState.imgWidth}}>
                     
                      <div  className={`imageDiv ${styles.imgSingle}`} onClick={()=>previewOpen(data)}>
                        <img src={messageBody.filePath} alt="" />
                        {multiData.length>=4 && 
                        <div className={multiData.length>4 && index === 3 ? styles.groupingnumber:""}>+{multiData.length - 3}</div>} </div>
                      {/* <div className={styles.attachmentHover} id={"hover"+data.id}>
                        <ChatAttachmentsOption data={data} fromFiles={false}  previewopen={previewOpen} hoverdata={Array.isArray(multiData) && multiData?.length > 0 && multiData[0]}/>
                        </div> */}
                  {(messageBody?.text === "" || messageBody?.text === undefined) &&   
                     <ChatGifInfo userDetails={userdetails}
                     timeStamp={data?.timestamp} message={data}></ChatGifInfo>
                   }
                  </div>}
    </>
  );
};



